import React, { useRef, useEffect, useCallback, useState} from 'react';
import {
    mouseDown,
    setSelectedPianoRollSteps} from 'actions/index.js';
import Dropdown from 'react-dropdown';
import PianoRollController from './PianoRollController.js';
import {connect} from 'react-redux';
import '../../PianoRollControl.scss';
import {WIDTH} from '../pianoroll/constants.js';

const MARGIN = 58;

const PARAMETER_OPTIONS = [
    {label: "Velocity", value: "velocity"},
    {label: "Panning", value: "panning"},
    {label: "Chop", value: "chop"},
    {label: "Release", value: "release"},
    {label: "Probability", value: "probability"},
];

const PianoRollControl = ({
    scroll,
    xScale,
    track,
    resolution,
    color,
    mouseDown
}) => { 
    let [controlParameter, setControlParameter] = useState("velocity");
    let width = WIDTH * xScale * track.getEasyPattern().pattern.length();
    var style = {
        width: width * 2
    };

    let ref = useRef(undefined);

    useEffect(() => {
        ref.current.addEventListener("mousewheel", onWheel, {passive: false});
        return () => ref.current && ref.current.removeEventListener("mousewheel", onWheel);
    }, [scroll]);

    const onWheel = useCallback((e) => {
        e.preventDefault();
        let x = e.deltaX;
        scroll.current.scrollTo(scroll.current.scrollLeft + x, 0);
        return false;
    }, [scroll]);

    useEffect(() => {
        if (scroll.current) {
            scroll.current.addEventListener("scroll", onScroll);
        }
        return () => scroll.current && scroll.current.removeEventListener("scroll", onScroll);
    }, [scroll.current]);

    const onScroll = useCallback(e => {
        if (ref.current && scroll.current) {
            ref.current.scrollTo(scroll.current.scrollLeft, 0);
        }
    }, [scroll]);

    let x = [];
    for (let i=0; i < 2000; i++) {
        x.push(i);
    }

    return (
        <div
          onMouseUp={() => mouseDown(false)}
          className="piano-roll-control">
          <div style={{backgroundColor: color}} className="control-choice">
            <Dropdown
              options={PARAMETER_OPTIONS}
              onChange={(o) => setControlParameter(o.value)}
              value={PARAMETER_OPTIONS.find(x => x.value === controlParameter)}
              placeholder="Parameter" />
 
          </div>
          <div
            ref={ref}
            className="controller-container">
            <PianoRollController controlParameter={controlParameter} color={color} track={track} xScale={xScale} style={style}/>
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      mouseDown: (x) => dispatch(mouseDown(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PianoRollControl);
